var map = {
	"./gallery-wip-construction-improvements-screw-replacement_00.jpg": 2958,
	"./gallery-wip-construction-improvements-screw-replacement_01.jpg": 2959,
	"./gallery-wip-construction-improvements-screw-replacement_02.jpg": 2960,
	"./gallery-wip-construction-improvements-screw-replacement_03.jpg": 2961,
	"./gallery_00.jpg": 2962,
	"./gallery_01.jpg": 2963,
	"./gallery_02.jpg": 2964,
	"./gallery_03.jpg": 2965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2957;